import React, { useState, useEffect, useRef } from "react";
import Page from "../../finwell/pages/Page";
import { useDispatch, useSelector } from "react-redux";
import {
  getWorkshop,
  getWorkshopClear,
  postWorkshop,
  postWorkshopClear,
  updateWorkshop,
  updateWorkshopData,
  updateWorkshopDataResponse,
  updateWorkshopResponseClear,
} from "../../redux/groupWorkshop/actions";
import _ from "lodash";
import "./GroupWorkShop.scss";
import Loader from "../../components/Loader/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import GroupWorkshopForm from "../../components/GroupWorkshop/GroupWorkshopForm";
import API_LIST from "../../utils/apiList";
import { SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import { routeList } from "../../utils/routeList";

const EditGroupWorkshopPage = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const postDataRef = useRef({});

  const params = new URLSearchParams(useLocation().search);
  const e = params.get('e')
  const r = params.get('r')

  const Weekdays = [
    { day: "Monday", id: "1" },
    { day: "Tuesday", id: "2" },
    { day: "Wednesday", id: "3" },
    { day: "Thursday", id: "4" },
    { day: "Friday", id: "5" },
    { day: "Saturday", id: "6" },
    { day: "Sunday", id: "7" },
  ];

  const languageOptions = [
    {
      value: "english",
      label: "English",
      id: "1",
    },
    {
      value: "french",
      label: "French",
      id: "2",
    },
  ];

  const groupWorkshopStore = useSelector((state) => state.groupworkshop);
  const getWorkshopDetail = useSelector((state) => state.groupworkshop.groupWorkshopData);
  const updateWorkshopStore = useSelector((state) => state.groupworkshop.updateWorkshopData);

  const [workshopData, setWorkshopData] = useState({});
  const [isMinuteSelected, setIsMinuteSelected] = useState(false);
  const [selectedOption, setSelectedOption] = useState("flexRadioDefault1");
  const [chips, setChips] = useState([]);
  const [participantChips, setParticipantChips] = useState([]);
  const [selectedTrainerId, setSelectedTrainerId] = useState([]);
  const [selectedParticipantId, setSelectedParticipantId] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [trainerValidation, setTrainerValidation] = useState("");
  const [memberValidation, setMemberValidation] = useState("");
  const [workshopValidation, setWorkshopValidation] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const [addDaysCount, setAddDaysCount] = useState("1");
  const [isDraft, setIsDraft] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [sessionOnlyUpdate, setSessionOnlyUpdate] = useState(false);

  useEffect(() => {
    if (e && !sessionOnlyUpdate) {
      const decoded = atob(e);
      const decodedData = JSON.parse(decoded);
      let event_id = ""
      let session_id = ""
      if (decodedData.workshopId) {
        event_id = decodedData.workshopId
      }
      if (decodedData.sessionId) {
        setSessionId(decodedData.sessionId)
        setSessionOnlyUpdate(true)
        session_id = decodedData.sessionId
      }
      if (!event_id) {
        navigate(`${routeList.GROUP_WORKSHOP_SESSION_DETAIL}?c=${r}`)
      } else {
        dispatch(
          getWorkshop({
            URL: CONFIG.API_URL_BROKER_ADMIN + API_LIST.BROKER_API.GET_WORKSHOP_DETAIL,
            payload: {
              event_id,
              session_id,
              token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            }
          })
        )
      }
    } else if (!e) {
      navigate("/learn/group-workshops")
    }
  }, [e, sessionOnlyUpdate])

  useEffect(() => {
    if (!_.isEmpty(getWorkshopDetail)) {
      const workshopDetail = getWorkshopDetail;
      if (workshopDetail?.status === "success") {
        if (workshopDetail?.payload?.data && !_.isEmpty(workshopDetail?.payload?.data?.workshop)) {
          setWorkshopData(workshopDetail?.payload?.data?.workshop);
        }
      } else {
        setError("Something went wrong");
        // setShowLimitPopup(true);
      }
      setIsLoading(false);
      dispatch(getWorkshopClear({}));
    }
  }, [getWorkshopDetail])


  // useEffect(() => {
  //   console.log("workshopSS", groupWorkshopStore)
  //   if (!_.isEmpty(groupWorkshopStore.groupWorkshopSubmit)) {
  //     const submitRes = groupWorkshopStore.groupWorkshopSubmit;
  //     if (submitRes?.status === "success") {
  //       setIsLoading(false);
  //       setShowModalMsg("Group workshop successfully created");
  //       setConfirmModal(true);
  //       dispatch(postWorkshopClear({}));
  //     } else {
  //       console.log("error ")
  //       setIsLoading(false);
  //       setError("Something went wrong");
  //       setShowLimitPopup(true);
  //       dispatch(postWorkshopClear({}));
  //     }
  //   }
  // }, [groupWorkshopStore]);

  useEffect(() => {
    if (!_.isEmpty(updateWorkshopStore)) {
      const updateData = updateWorkshopStore;
      if (updateData?.status === "success") {
        setIsLoading(false);
        setShowModalMsg("Group workshop successfully updated");
        setConfirmModal(true);
        setTimeout(() => {
          navigate("/learn/group-workshops")
        }, 2000);
      } else {
        console.log("error ")
        setIsLoading(false);
        setError("Something went wrong");
        setShowLimitPopup(true);
      }
      dispatch(updateWorkshopDataResponse({}));
    }
  }, [updateWorkshopStore]);


  const handleSubmitForm = (payload) => {
    console.log("payload", payload)
    setIsLoading(true);
    payload.workshop_id = workshopData.event_id
    dispatch(
      updateWorkshopData({
        URL: CONFIG.API_URL_BROKER_ADMIN + API_LIST.BROKER_API.UPDATE_WORKSHOP_DETAIL,
        payload: payload,
      })
    );
  }



  return (
    <>
      <Page>
        <Loader start={isLoading} />
        <GroupWorkshopForm
          pageLine={`Edit Masterclass`}
          workshopData={workshopData}
          sessionId={sessionId}
          setSessionId={setSessionId}
          sessionOnlyUpdate={sessionOnlyUpdate}
          setSessionOnlyUpdate={setSessionOnlyUpdate}
          handleSubmitForm={handleSubmitForm}
          confirmModal={confirmModal}
          setConfirmModal={setConfirmModal}
          showModalMsg={showModalMsg}
          // setShowModalMsg={setShowModalMsg}
          // isLaoding={isLoading}
          setIsLoading={setIsLoading}
          error={error}
          setError={setError}
          showLimitPopup={showLimitPopup}
          setShowLimitPopup={setShowLimitPopup}
          btnName={!workshopData?.is_draft ? "publish" : "Unpublish"}
          saveBtn={true}
          setIsDraft={setIsDraft}
        />
      </Page>
    </>
  );
};

export default EditGroupWorkshopPage;
